<template>
  <div
    v-if="show"
    class="mobile-page fullscreen-fixed flex-center"
    :style="{ 'background-color': 'transparent' }"
  >

    <div class="container" :style="{zoom: qrDevice ? 0.5 : 0.9}">
      <p class="header-text" :style="{ color: $store.registratorCaptionColor }">
      {{ 'booking_by_phone' | translate }}
    </p>

      <div class="phone-container">
        <MobilePhoneControl v-model="phoneNumber" @update:countryDialCode="handleCountryDialCode"/>

        <div class="button-container">
          <button
            class="button-confirm"
            :style="{
              color: $store.registrator_text_btn,
              backgroundColor: $store.registratorBackgroundBtnColor,
            }"
             @click="handleServiceClick(phoneNumber)"
          >
            {{ 'registrator_button_next' | translate }}
          </button>

          <button
            class="button-cancel"
            :style="{ color: $store.registratorCaptionColor }"
            @click="cancelEnteringPhoneNumber()"
          >
            {{ 'd_ws_button_cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalMixin from '../mixins/ModalMixin';
import MobilePhoneControl from './MobilePhoneControl';

export default {
  name: 'MobilePreRecordPage',
  mixins: [ModalMixin],
  components: {
    MobilePhoneControl,
  },
  props: {
    qrDevice: {
      type: Boolean
    },
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phoneNumber: '',
      countryDialCode: '',
    };
  },
  methods: {
    handleServiceClick(service) {
      const phone = `${this.countryDialCode}${service}`
      this.pickTicket(phone);
      this.phoneNumber = '';
    },
    pickTicket(ticket) {
      this.$emit('pickTicket', ticket);
    },
    cancelEnteringPhoneNumber() {
      this.phoneNumber = '';
      this.closeModal()
      this.$emit('cancelEnteringPhoneNumber');
    },
    handleCountryDialCode(countryDialCode) {
      this.countryDialCode = countryDialCode;
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-page {
  flex-direction: column;
  height: calc(100vh - min(9.765625vh, 100px));
  margin-top: min(9.765625vh, 100px);
  z-index: 1;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}

.phone-container {
  width: 615px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: min(54px, 5.2734375vh);
}

.button-container {
  width: 304px;
  margin-top: min(56px, 5.46875vh);
}

.button {
  &-confirm,
  &-cancel {
    min-height: 80px;
    border: none;
    background: none;
    font-weight: 600;
    font-size: 24px;
    text-transform: uppercase;
    border-radius: 20px;
  }
  &-confirm {
    box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074),
      0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
    min-width: 304px;
  }
  &-cancel {
    min-width: 240px;
  }
}

.header-text {
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  margin-top: min(24px, 2.222vh);
  padding: 0 32px;
}

.header-wrapper {
  width: 100%;
  height: 14.453125vh;
}
@media screen and (min-height: 1024px) {
 .device-registrator{
   .header-wrapper {
     height: 100px;
   }
 }
}
@media screen and (min-height: 445px) {
  .button-container{
    display: flex;
    padding-left: 40px;
    justify-content: center;
  }
}
</style>
